export default class Visitor {
    constructor(model) {
        return model;
    }
}
